import React from "react";
import {
  CustomDataTable
} from "../../../components/CommnTable/CustomDataTable";
import usePastStudentEvaluation from "./usePastStudentEvaluation";
import { PastStudentEvaluationList } from "../../../types/types";
import { Card, Box, Typography, Chip } from "@mui/material";
import styles from "../../ScholarshipApplication/ScholarshipApplicationDetails/ScholarshipApplicationDetails.module.scss";


const PastStudentEvaluation = () => {
  const { columns, data, limitValue, HandlePagination, studentEvaluationDetail } = usePastStudentEvaluation()
  return (<Card
    style={{
      padding: "1rem",
      border: 0,
      boxShadow: "none",
      background: "none",

    }}
  >
    <Box className={"cardBoxUI cardBoxOtherUI"}>
      <Box className={styles.header} mb={4}>
        <Box className={styles.navigationButtons}>
          <Typography variant="h6">
            Student Name
          </Typography>
         {studentEvaluationDetail?.name && <Chip label={studentEvaluationDetail?.name} color="info" sx={{ fontSize: 16 }} />}
          </Box>
        <Box className={styles.navigationButtons}><Typography variant="h6">
          Scholarship ID
        </Typography>
        {studentEvaluationDetail?.scholarship_id && <Chip label={studentEvaluationDetail?.scholarship_id} color="success" sx={{ fontSize: 16 }} />}
        </Box>
      </Box>
      <CustomDataTable<PastStudentEvaluationList>
        data={data}
        columns={columns}
        tableTitle="Past Evaluation List"
        rowsPerPage={limitValue}
        onPageChange={HandlePagination}
        exportExcelShow={true}
      />
    </Box>
  </Card>)
}

export default PastStudentEvaluation